<header class="flex justify-content-between align-items-center p-3">
  <span>
    {{ title() }}
  </span>

  <p-toggleswitch
    [ngModel]="toggled()"
    (onChange)="toggleChange.emit($event.checked)"
    [disabled]="disabled()"
  />
</header>

<main class="toggle-card-body" [class.expanded]="toggled()">
  <div>
    <div class="border-top-1 border-300 p-3">
      <ng-content />
    </div>
  </div>
</main>
